import Vue from 'vue'
import requisitionTransformer from '@/transformers/catalog/warehouse/requisitionSM'

/**
 * @author jorge nuñez lópez <>
 *
 * Pass sinister to status PT
 * @param wqId Warehouse Quantification Id 
 */

export default (wqId) => {
  return Vue.$http.post(`iwarehouse/iwarehouse-quantification/pass-to-pt/`, { iwarehouse_quantification_id: wqId })
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/passToPT.js